import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Modal } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class SchedulePendenciesPending extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      staff_schedule_request_id: null,
      manager_answer_reason: null,
      modal: false,
      data: []
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.archive = this.archive.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }


  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/pendencias/abertas', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  archive (id) {
    var confirm = window.confirm(this.locale.PendenciasDeEscala.ListaDePendenciasNaoResolvidas.arquivarPendencia);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      var datasave = {
        id: id,
      };

      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/pendencia/arquivar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({data: responseJson.data});
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  ActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        <button className="btn btn-sm btn-success" value={cell} onClick={() => this.archive(cell)}>
          <i className="fa fa-fw fa-download"></i> {this.locale.PendenciasDeEscala.ListaDePendenciasNaoResolvidas.botaoArquivar}
        </button>
      </div>
    );

    return botao;
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.PendenciasDeEscala.ListaDePendenciasNaoResolvidas.titulo}</h3>
      <hr/>
        <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.PendenciasDeEscala.ListaDePendenciasNaoResolvidas.tabela.semPendencias}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

            <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.PendenciasDeEscala.ListaDePendenciasNaoResolvidas.tabela.Acoes}</TableHeaderColumn>
            
            <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.PendenciasDeEscala.ListaDePendenciasNaoResolvidas.tabela.ID}</TableHeaderColumn>

            <TableHeaderColumn dataField="date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.PendenciasDeEscala.ListaDePendenciasNaoResolvidas.tabela.Data}</TableHeaderColumn>
            <TableHeaderColumn dataField="staff_inscription" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='70'>{this.locale.PendenciasDeEscala.ListaDePendenciasNaoResolvidas.tabela.Matricula}</TableHeaderColumn>
            <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='150'>{this.locale.PendenciasDeEscala.ListaDePendenciasNaoResolvidas.tabela.Nome}</TableHeaderColumn>

            <TableHeaderColumn dataField="schedule_daily_id" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='70'>{this.locale.PendenciasDeEscala.ListaDePendenciasNaoResolvidas.tabela.EscalaDiariaID}</TableHeaderColumn>
            <TableHeaderColumn dataField="schedule_daily_base_abbreviation" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.PendenciasDeEscala.ListaDePendenciasNaoResolvidas.tabela.EscalaDiariaBase}</TableHeaderColumn>

            <TableHeaderColumn dataField="flight_report_id" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='70'>{this.locale.PendenciasDeEscala.ListaDePendenciasNaoResolvidas.tabela.RelatorioDeVooID}</TableHeaderColumn>
            <TableHeaderColumn dataField="flight_report_base_abbreviation" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.PendenciasDeEscala.ListaDePendenciasNaoResolvidas.tabela.RelatorioDeVooBase}</TableHeaderColumn>

            <TableHeaderColumn dataField="schedule_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='70'>{this.locale.PendenciasDeEscala.ListaDePendenciasNaoResolvidas.tabela.EscalaDeMissao}</TableHeaderColumn>
            <TableHeaderColumn dataField="schedule_base_abbreviation" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.PendenciasDeEscala.ListaDePendenciasNaoResolvidas.tabela.EscalaDeMissaoBase}</TableHeaderColumn>

        </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default SchedulePendenciesPending;



// WEBPACK FOOTER //
// ./src/Components/SchedulePendencies/SchedulePendenciesPending.js